import { Directive, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Diretiva de máscara para telefone celular brasileiro: (99) 99999-9999
 * Compatível com ion-input + Reactive Forms / ngModel.
 * Uso: <ion-input [formControlName]="..." appPhoneMask>
 *      <ion-input [(ngModel)]="..." appPhoneMask>
 */
@Directive({
    selector: '[appPhoneMask]',
})
export class PhoneMaskDirective {
    constructor(@Self() private ngControl: NgControl) {}

    // <ion-input> dispara 'ionInput'
    @HostListener('ionInput', ['$event.detail.value'])
    onIonInput(raw: string): void {
        this.aplicar(raw);
    }

    // <input> nativo dispara 'input' (ionInput nunca chega aqui)
    @HostListener('input', ['$event.target.value'])
    onNativeInput(raw: string): void {
        this.aplicar(raw);
    }

    private aplicar(raw: string): void {
        this.ngControl.control?.setValue(this.applyMask(raw), { emitEvent: false });
    }

    private applyMask(value: string): string {
        const v = (value || '').replace(/\D/g, '').slice(0, 11);
        if (v.length > 6) return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7)}`;
        if (v.length > 2) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
        if (v.length > 0) return `(${v}`;
        return v;
    }
}
